<ui-embed-empty [uiComponentName]="'list'" [uiSpecificContent]="nzNoResult"></ui-embed-empty>
